import { Form, Row, Col } from "react-bootstrap";
import { FiStar } from "react-icons/fi";
import { useState } from "react";
// import AddDealModal from "../AddDealModal";
// import EditContactModall from "../EditContactModal";
import EditContactModal from "../EditContactModal";
import AddDealModal from "../AddDealModal";
const BasicInfoTab = () => {
  const [showDealModal, setShowDealModal] = useState(false);
  const [tagInput, setTagInput] = useState("");
  const [tagList, setTagList] = useState(["Collab"]);
  const [contactInput, setContactInput] = useState("");
  const [contactList, setContactList] = useState(["Sharon Roy"]);
  const [optionEnabled, setOptionEnabled] = useState(false);
  const [addDeal, setAddDeal] = useState(false);


  // Add tag
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && tagInput.trim() !== "") {
      e.preventDefault();

      if (!tagList.includes(tagInput.trim())) {
        setTagList([...tagList, tagInput.trim()]);
      }

      setTagInput("");
    }
  };

  const handleContactKeyDown = (e) => {
    if (e.key === "Enter" && contactInput.trim() !== "") {
      e.preventDefault();

      if (!contactList.includes(contactInput.trim())) {
        setContactList([...contactList, contactInput.trim()]);
      }

      setContactInput("");
    }
  };

  // Remove tag
  const removeTag = (index) => {
    setTagList(tagList.filter((_, i) => i !== index));
  };

  const removeContact = (index) => {
    setContactList(contactList.filter((_, i) => i !== index));
  };

  return (
    <>
      <Row>
        <Col md={6}>
          <Form.Label>Company Name *</Form.Label>
          <Form.Control placeholder="Company Name" />
        </Col>
        <Col md={6}>
          <div className="d-flex justify-content-between align-items-start">
            <div style={{ width: "100%" }}>
              <Form.Label>Email</Form.Label>
              <Form.Control placeholder="Email" />
            </div>
            <Form.Check
              type="switch"
              id="company-option-switch"
              label="Option"
              checked={optionEnabled}
              onChange={() => setOptionEnabled(!optionEnabled)}
              className="mt-4 ms-3"
            />
          </div>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={6}>
          <Form.Label>Phone Number *</Form.Label>
          <Form.Control placeholder="Phone Number" />
        </Col>
        <Col md={6}>
          <Form.Label>Phone Number 2</Form.Label>
          <Form.Control placeholder="Phone Number 2" />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={6}>
          <Form.Label>Fax</Form.Label>
          <Form.Control placeholder="Fax" />
        </Col>
        <Col md={6}>
          <Form.Label>Website</Form.Label>
          <Form.Control placeholder="Website" />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={6}>
          <Form.Label>Ratings *</Form.Label>
          <div className="rating-box">
            <Form.Control placeholder="Ratings" />
            <FiStar />
          </div>
        </Col>
        <Col md={6}>
          <Form.Label>Owner *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={6}>
          <Form.Label>Tags *</Form.Label>
          <div className="tags-box">
            {tagList.map((tag, index) => (
              <span key={index}>
                {tag}
                <button type="button" onClick={() => removeTag(index)}>
                  ✕
                </button>
              </span>
            ))}
            <input
              type="text"
              placeholder="Add new"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
        </Col>
        <Col md={6}>
          <div className="d-flex justify-content-between">
            <Form.Label>Deals *</Form.Label>
            <span className="add-new" onClick={() => setShowDealModal(true)}>
              + Add New
            </span>
          </div>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={6}>
          <Form.Label>Industry *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
        <Col md={6}>
          <Form.Label>Source *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={6}>
          <Form.Label>Currency *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
        <Col md={6}>
          <Form.Label>Language *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={12}>
          <Form.Label>About *</Form.Label>
          <Form.Control as="textarea" rows={4} placeholder="About" />
        </Col>
      </Row>

      

      <Row className="mt-3">
        <Col md={12}>
            <div className="d-flex justify-content-between">
            <Form.Label>Contacts</Form.Label>
            <span className="add-new" onClick={() => setShowDealModal(true)}>
              + Add New
            </span>
          </div>
          <div className="tags-box">
            {contactList.map((contact, index) => (
              <span key={index}>
                {contact}
                <button type="button" onClick={() => removeContact(index)}>
                  ✕
                </button>
              </span>
            ))}
            <input
              type="text"
              placeholder="Add new"
              value={contactInput}
              onChange={(e) => setContactInput(e.target.value)}
              onKeyDown={handleContactKeyDown}
            />
          </div>
        </Col>
      </Row>
 
       <EditContactModal
        show={showDealModal}
        handleClose={() => setShowDealModal(false)}
      /> 
      <AddDealModal
        show={showDealModal}
        handleClose={() => setShowDealModal(false)}
      />
      {/* STYLES */}
      <style>{`
        .custom-select:focus {
          border-color: #ff6b2c;
          box-shadow: 0 0 0 0.2rem rgba(255,107,44,0.2);
        }

        option:checked {
          background: #ff6b2c;
          color: white;
        }

        .rating-box {
          position: relative;
        }

        .rating-box svg {
          position: absolute;
          right: 10px;
          top: 10px;
        }

        .tags-box {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          border: 1px solid #ddd;
          padding: 8px;
          border-radius: 8px;
          min-height: 45px;
          align-items: center;
        }

        .tags-box span {
          background: #e5e7eb;
          padding: 4px 8px;
          border-radius: 6px;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
        }

        .tags-box button {
          border: none;
          background: none;
          cursor: pointer;
          padding: 0;
          font-size: 13px;
        }

        .tags-box input {
          border: none;
          outline: none;
          flex: 1;
          min-width: 140px;
        }

        .add-new {
          color: #ff6b2c;
          font-size: 13px;
          cursor: pointer;
        }
      `}</style>
    </>
  );
};

export default BasicInfoTab;
